import { createActions, createReducer } from 'reduxsauce'

import DespesasPorOrgaoService from '../../servicos/DespesasPorOrgaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasPorOrgaoInicio: [],
    buscaDespesasPorOrgaoSucesso: ['despesasPorOrgao'],
    buscaDespesasPorOrgaoErro: ['erro'],
    setSelecionadoPorOrgaoSucesso: ['selecionado'],
    setDespesasPorOrgaoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasPorOrgao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDespesasPorOrgaoInicio())
        let serv = new DespesasPorOrgaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDespesasPorOrgaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasPorOrgaoErro(error)))
    }
}

const buscaDespesasPorOrgaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasPorOrgaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDespesasPorOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasPorOrgao.resultado, dataAtualizacaoDados: action.despesasPorOrgao.dataAtualizacaoDados, carregando: false }
}

const setSelecionadoPorOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setDespesasPorOrgaoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_POR_ORGAO_INICIO]: buscaDespesasPorOrgaoInicio,
    [Types.BUSCA_DESPESAS_POR_ORGAO_ERRO]: buscaDespesasPorOrgaoErro,
    [Types.BUSCA_DESPESAS_POR_ORGAO_SUCESSO]: buscaDespesasPorOrgaoSucesso,
    [Types.SET_SELECIONADO_POR_ORGAO_SUCESSO]: setSelecionadoPorOrgaoSucesso,
    [Types.SET_DESPESAS_POR_ORGAO_ESTADO_DT]: setDespesasPorOrgaoEstadoDT,
})
